import React, { useEffect } from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";

const Footer = () => {

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [pathname]);
  return (
    <>
      <section className="footer_section">
        <div className="container">
          <div className="row justify-content-md-center">

            <div className="col-lg-3 mb-3 ">
              <div className="footlogodiv">
                <Link to="/Home">
                  <img
                    className="footlogoimg"
                    src="/assets/images/logo/logo.png"
                    alt="Ashva Sports Logo"
                  />
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
              <div className="menusec">
                <h6 className="menutitle">Quick Links</h6>

                <div className="menudiv">
                  {/* <Link to="/">Home</Link> */}
                  <Link
                    to="/"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}> Home </Link>
                </div>

                <div className="menudiv">
                  <Link to="/about-us"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}>About Us</Link>
                </div>

                <div className="menudiv">
                  <Link to="/sports-programs"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}>Sports Programs</Link>
                </div>



                <div className="menudiv">
                  <Link to="/contact-us"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}>Contact Us</Link>
                </div>

              </div>
            </div>


            <div className="col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
              <div className="menusec">
                <h6 className="menutitle">Support</h6>
                <div className="menudiv">
                  <Link
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }} to="terms-conditions">Terms & Conditions</Link>
                </div>
                <div className="menudiv">
                  <Link
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }} to="privacy-policy">Privacy Policy</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-8 mb-3">
              <div className="menusec">
                <h6 className="menutitle">Follow us</h6>


                <div className="socialicons">
                  <Link to={"https://facebook.com"} target="_blank">
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icons/facebook.png"
                      }
                    />
                  </Link>

                  <Link to={"https://google.com"} target="_blank">
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icons/google.png"
                      }
                    />
                  </Link>

                  <Link to={"https://twitter.com"} target="_blank">
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icons/twitter.png"
                      }
                    />
                  </Link>

                  <Link to={"https://linkedin.com"} target="_blank">
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icons/linkdin.png"
                      }
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
      <div className="copyrightsec">
        <p className="copyrightp">
          © 2026 Ashva Sports & Fitness All Rights Reserved | Developed by{" "}
          <Link to={"https://profcymaglobal.com/"} target="_blank">
            Profcyma Solutions Pvt Ltd
          </Link>
        </p>
      </div>
    </>
  );
};

export default Footer;
